import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import garden from "../assets/new-ui/gameplay/gameplay-header-new.png";
import bedroom from "../assets/new-ui/gameplay/gameplay-middle-new.png";
// import character from '../assets/new-ui/vision/shark-hades.png'
import city from "../assets/new-ui/gameplay/gameplay-city-new.png";
import headShark0 from "../assets/new-ui/gameplay/gameplay-icon-default.png";
import headShark1 from "../assets/new-ui/gameplay/gameplay-icon-1.gif";
import headShark2 from "../assets/new-ui/gameplay/gameplay-icon-2.gif";
import headShark3 from "../assets/new-ui/gameplay/gameplay-icon-3.gif";
import headShark4 from "../assets/new-ui/gameplay/gameplay-icon-4.gif";
import headShark5 from "../assets/new-ui/gameplay/gameplay-icon-5.gif";
import headShark6 from "../assets/new-ui/gameplay/gameplay-icon-6.gif";
import headShark7 from "../assets/new-ui/gameplay/gameplay-icon-7.gif";
import headShark8 from "../assets/new-ui/gameplay/gameplay-icon-8.gif";
import headShark9 from "../assets/new-ui/gameplay/gameplay-icon-9.gif";
import headShark10 from "../assets/new-ui/gameplay/gameplay-icon-10.gif";
import headShark11 from "../assets/new-ui/gameplay/gameplay-icon-11.gif";
import headShark12 from "../assets/new-ui/gameplay/gameplay-icon-12.gif";
import ConnectWallet from "../components/ConnectWallet";

import Aphrodite from "../assets/new-ui/gameplay/Aphrodite-light.gif";
import Apollo from "../assets/new-ui/gameplay/Apollo-light.gif";
import Athena from "../assets/new-ui/gameplay/Athena-light.gif";
import Hephestus from "../assets/new-ui/gameplay/Hephestus-light.gif";
import Poseidon from "../assets/new-ui/gameplay/Poseidon-light.gif";
import Ring from "../assets/new-ui/gameplay/Ring.png";
import sharkHades from "../assets/new-ui/vision/Hades-small.gif";
import hadesFire from "../assets/new-ui/vision/Hades-Fire.png";
import CoralLeftType2 from "../components/coral/CoralLeftType2";
import Bubble from "../components/coral/Bubble";

//import about metaverse

// import imgHeader from '../assets/new-ui/about-metaverse/img-header.png'
// import sharkAngle from '../assets/new-ui/about-metaverse/shark-angle.png'
// import CustomButton from "../components/CustomButton"
// import decorTagBox from '../assets/new-ui/about-metaverse/decor-tag-box.png'

export default function GamePlay() {
  return (
    <div className="pageContainer gamePlayContainer aboutMetaverseContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <CoralLeftType2 />
      <Bubble top={"200px"} />
      <div className="gamePlayHeader">
        <div className="gamePlayHeaderTitle">METAVERSE GAMEPLAY</div>

        <div className="garden">
          <div className="gardenText">
            <div>Do you want to be a part of the Sharktopia metaverse?</div>
            <div>
              Would you like to be someone you admire in the real world?
            </div>
            <div>
              In the world of Sharktopia, you can create your own unique, cute
              sharks, chat, grow crops, raise livestock on your farm, exploit,
              play simple games with friends, build a home, etc. Everything is
              here, in the world of Sharktopia – Ocean economy.
            </div>
          </div>
          <div className="gardenImg">
            <img src={garden} alt="garden gif" />
            {/* <div>We are developing 3D art of the game, this background based on an other product, the final art will have differences</div> */}
          </div>
        </div>

        <div className="script">
          <div className="hadesGod">
            <img src={hadesFire} alt="desciption" />
            <img src={sharkHades} alt="desciption" />
          </div>
          {/* <img src={character} alt='character' /> */}
          <div className="scriptText">
            <div>GAME SCRIPT</div>
            <div>
              The game's main scenario will be a playground in which the player
              will be centered and explore the world in the game through his
              activities.
            </div>
            <div>
              At the beginning of the game, the player will play with Sharks
              based on the NFTs they own, then joins the battle to hold fields,
              mines, sheds, fields, and a simple little house. After that, they
              will participate in activities such as planting trees, raising
              livestock, mining, fishing, decorating homes, studying, and
              gradually gaining rewards and items used to upgrade attributes of
              sharks, or buy new plants, animals, tools to increase Sharks
              abilities.
            </div>
          </div>
        </div>
      </div>

      <div className="gamePlayMiddle">
        <div className="introduce">
          <div className="stepIntro">
            <div className="stepElement">
              <img src={headShark0} alt="head shark" />
              <div className="stepElementText">
                <div>
                  Players can evaluate their strength and that of others through
                  the following factors:
                </div>
                <ul>
                  <li>Skills</li>
                  <li>Level</li>
                  <li>Item in possession</li>
                </ul>
              </div>
            </div>

            <div className="stepElement">
              <img src={headShark0} alt="head shark" />
              <div className="stepElementText">
                <div>There are also community features like:</div>
                <ul>
                  <li>Making friend</li>
                  <li>Countervailing</li>
                  <li>Giving a gift</li>
                  <li>Chatting</li>
                </ul>
              </div>
            </div>

            <div className="stepElement">
              <img src={headShark0} alt="head shark" />
              <div className="stepElementText">
                <div>
                  By participating in in-game activities, the player will affect
                  the shark's five stats:
                </div>
                <ul>
                  <li>Skill</li>
                  <li>God ability</li>
                  <li>Speed</li>
                  <li>HP</li>
                  <li>Defense</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="includeIntro">
            Stats can be improved if the player balances all his tasks in the
            game. Then, they will level up and conquer more extensive missions
            when balancing good stats and steadily increasing stats - more
            significant rewards.
          </div>
        </div>
        <div className="gamePlayMiddleTitle">
          Classification of areas according to specific functions
        </div>

        <div className="city">
          <Bubble top={"-50%"} />
          <div className="cityText">
            <div className="cityRow">
              <div className="cityElement">
                <img src={headShark1} alt="head shark" />
                <div className="title">1. Farm</div>
                <ul>
                  <li>Buy seeds, pesticides, fertilizer and other products</li>
                  <li>Planting, caring and harvesting.</li>
                </ul>
              </div>

              <div className="cityElement">
                <img src={headShark2} alt="head shark" />
                <div className="title">2. Breeding in livestock areas</div>
                <div className="description">
                  Players can choose to raise pets such as Cows, Sheep, Pigs,
                  Chickens, and Ducks.
                </div>
              </div>

              <div className="cityElement">
                <img src={headShark3} alt="head shark" />
                <div className="title">3. Mine area</div>
                <div className="description">
                  There are mines such as uranium ore, diamond, gold, silver,
                  etc. Used to forge items that help increase the attributes of
                  sharks.
                </div>
              </div>

              <div className="cityElement">
                <img src={headShark4} alt="head shark" />
                <div className="title">4. Shopping mall</div>
                <div className="description">
                  Shopping area to buy assistant things to help with the harvest
                  when the player is not online or eliminate harm in farming and
                  breeding. There are also skill cards and items that increase
                  the Sharks attribute.
                </div>
              </div>

              <div className="cityElement">
                <img src={headShark5} alt="head shark" />
                <div className="title">5. Fishing-zone</div>
                <div className="description">
                  Fishing activities take place very excitingly at many clusters
                  of lakes with many different types of fish. Fishing will help
                  players practice patience, perseverance, etc
                </div>
              </div>

              <div className="cityElement">
                <img src={headShark6} alt="head shark" />
                <div className="title">6. Entertainment area</div>
                <div className="description">
                  Players can also bet in each game to increase income, where
                  you will have fun with your friends or the community, with fun
                  games like Tic and Toe, Pet Racing, Rock-Paper-Scissors, etc.
                </div>
              </div>
            </div>
          </div>
          <div className="cityImg">
            <img src={city} alt="city shark" />
            {/* <div>We are developing 3D art of the game, this background based on an other product, the final art will have differences</div> */}
          </div>
        </div>

        <div className="room">
          <div className="roomImg">
            <img src={bedroom} alt="bedroom shark" />
            {/* <div>We are developing 3D art of the game, this background based on an other product, the final art will have differences</div> */}
          </div>

          <div className="cityElement">
            <img src={headShark7} alt="head shark" />
            <div className="title">7. Residential area</div>
            <div className="description">
              Players can choose to buy a house; there are five types of homes:
            </div>
            <ul>
              <li>Cottage</li>
              <li>Studio apartment for 1 person (inn/apartment room)</li>
              <li>Luxury apartment (townhouse, two floors)</li>
              <li>Villa (large area, garden, swimming pool)</li>
              <li>
                Mega villa (massive area with garden, swimming pool,
                golf/tennis/gym/bowling/archery course, pet area, hot mineral
                springs, parking lot, spa, wine cellar area, mini cinema, etc)
              </li>
            </ul>
            <div className="description">
              When owning a house, players will have the following privileges:
            </div>
            <ul>
              <li>
                Players in the friend's list can freely visit other players'
                homes.
              </li>
              <li>The host can invite someone to the house to play.</li>
              <li>
                Invite other players out of the house if you don't want them to
                stay in your house anymore or ban someone from entering your
                house, etc.
              </li>
            </ul>
            <div className="description">
              => The house with a high rating helps Sharks recover their health
              faster.
            </div>
          </div>
        </div>

        <div className="others">
          <div className="cityElement">
            <img src={headShark8} alt="head shark" />
            <div className="title">8. Teleport Area</div>
            <div className="description">
              Many monsters are lurking in the depths of the sea, which the
              player can only access through the Teleport Area. These are the
              seas such as the Pacific Ocean, Atlantic ocean, Indian ocean,
              Bermuda, bay of Bengal, etc.
            </div>
          </div>

          <div className="cityElement">
            <img src={headShark9} alt="head shark" />
            <div className="title">9. Holy Kingdom</div>
            <div className="description">
              {" "}
              To create a kingdom, you need a certain amount of GDC The kingdom
              will have its stage, where players must capture resources and
              invade other kingdoms according to tournaments to win items that
              increase sharks' attributes.
            </div>
          </div>

          <div className="cityElement">
            <img src={headShark10} alt="head shark" />
            <div className="title">10. Holy Arena</div>
            <div className="description">
              Defeat other players in PVP format to get a high rank and get the
              daily reward of GDC.
            </div>
          </div>

          <div className="cityElement">
            <img src={headShark11} alt="head shark" />
            <div className="title">11. Holy War space</div>
            <div className="description">
              Each sea has its number of stages to fight for GDC daily; the more
              complex the level, the more GDC you need and the higher the need
              for Sharks.
            </div>
          </div>

          <div className="cityElement">
            <img src={headShark12} alt="head shark" />
            <div className="title">12. Tatarus</div>
            <div className="description">
              For a certain time, the whole Holyworld will fight monsters
              together and divide equally the GDC rewards, items that increase
              attributes based on the amount of damage contributed and the last
              hit will receive the most.
            </div>
          </div>
        </div>

        <div className="comingSoon">
          AND MANY INTERESTING ACTIVITIES COMING SOON
        </div>
      </div>

      {/* About Metaverse Old */}
      <div className="pageHeader">
        {/* <div className='pageTitle'>ABOUT<br/>THE METAVERSE GAME</div> */}
        <div className="description">
          Insanely addictive and deeply strategic turn based tactics game that
          can be enhanced through playing with your owned Sharks from the NFT
          project.
        </div>
        <div className="descriptionMore">
          <span>Collect, Battle</span> and <span>Ocean Economy</span> in
          Sharktopia Metaverse gameplay.
        </div>
        {/* <div className='groupBtn'>
          <div className='bigBtn' onClick={() => setRouteFeature(true)}>
            <div>GAME HIGHLIGHTS</div>
            <div>View the top 5 reasons to play Sharktopia Game.</div>
          </div>
          <div className='smallBtn'>
            CINEMATIC <br/>TRAILER
          </div>
        </div> */}
      </div>

      {/* <img src={imgHeader} alt='img header' className='imgHeader' /> */}

      <div className="gameFeature">
        <div className="featureTitle">GAME FEATURES</div>
        <div className="featureDescription">
          Sharktopia Metaverse Game is a fun and enjoyable tactical RPG, find
          out about the main features of the game below.
        </div>
        <div className="featureList">
          <div className="featureItem">
            <div className="godLabel">
              <img src={Ring} alt="ring" />
              <img src={Athena} alt="shark god" />
            </div>
            {/* <img src={sharkAngle} alt='shark angle' /> */}
            <div className="featureDesciption">
              <div>Deep strategy and tactical role playing battles</div>
              <div>
                Turn-based combat that will challenge your tactical skills to
                their limits. The matches are designed in an engaging way so you
                can really enjoy the game.
              </div>
            </div>
          </div>

          <div className="featureItem">
            <div className="godLabel">
              <img src={Ring} alt="ring" />
              <img src={Hephestus} alt="shark god" />
            </div>
            {/* <img src={sharkAngle} alt='shark angle' /> */}
            <div className="featureDesciption">
              <div>Huge variety and endless battle combinations</div>
              <div>
                Given the number of parts available, combinations can create
                trillions of different characters, each with unique skills and
                abilities, that each brings something different to the
                battlefield.
              </div>
            </div>
          </div>

          <div className="featureItem">
            <div className="godLabel">
              <img src={Ring} alt="ring" />
              <img src={Poseidon} alt="shark god" />
            </div>
            {/* <img src={sharkAngle} alt='shark angle' /> */}
            <div className="featureDesciption">
              <div>Integrates with Sharktopia NFTs</div>
              <div>
                Bring your unique Sharks to life in the Metaverse Game and play
                with your owned digital assets.
              </div>
            </div>
          </div>

          <div className="featureItem">
            <div className="godLabel">
              <img src={Ring} alt="ring" />
              <img src={Aphrodite} alt="shark god" />
            </div>
            {/* <img src={sharkAngle} alt='shark angle' /> */}
            <div className="featureDesciption">
              <div>Simulate the economy as close to reality</div>
              <div>
                We try to design features that are similar to the real economy,
                to ensure the flow of money in the game and store value, and you
                can make investment decisions right in the game.
              </div>
            </div>
          </div>

          <div className="featureItem">
            <div className="godLabel">
              <img src={Ring} alt="ring" />
              <img src={Apollo} alt="shark god" />
            </div>
            {/* <img src={sharkAngle} alt='shark angle' /> */}
            <div className="featureDesciption">
              <div>Free to play and play to earn</div>
              <div>
                You can earn GDC in the game and you have full ownership of your
                assets, directly in the game as you.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='featureTags'>
        <div className='tag bigTags'>
          <div className='tagTitle'>About Sharktopia</div>
          <div className='tagDescription'>Frequently asked questions</div>
          <CustomButton 
            text={'VIEW DETAIL'} 
            textColor={'black'} 
            fn={() => history.push('/about-Sharktopia')}
            type={'small'}
            transparent={false}
          />
        </div>

        <div className='tag smallTags'>
          <div className='tagTitle'>About NFTs</div>
          <div className='tagDescription'>What exactly are Sharktopia?</div>
          <CustomButton 
            text={'VIEW DETAIL'} 
            textColor={'black'} 
            fn={() => history.push('/about-nft')}
            type={'small'}
            transparent={false}
          />
          <img src={decorTagBox} alt='decor' />
        </div>
      </div> */}
      {/* End About Metaverse Old */}
      <div className="gamePlayFooter">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
